
import { Component, mixins } from '@niknevis/vue-modules'
import AdminDepartmentSearch from '@/modules/department/components/admin/AdminDepartmentSearch.vue'
import { DepartmentRoute } from '@/modules/department/routes/department.route'

@Component
export default class DepartmentSearch extends mixins(AdminDepartmentSearch) {
  constructor(
    private readonly routes: DepartmentRoute
  ) {
    super()
  }

  protected get route(): string {
    return this.routes.search()
  }
}
